// Guarda el dispatch del store de Web Chat (se captura en el store
// middleware de App.tsx) para poder inyectar actividades locales en
// el transcript — p.ej. el log SQL de debug — sin pasar por Direct
// Line ni por el bot.
let webChatDispatch: any = null;

export const setWebChatDispatch = (dispatch: any) => {
  webChatDispatch = dispatch;
};

export const dispatchToWebChat = (action: any) => {
  if (webChatDispatch) webChatDispatch(action);
};
